<section class="users-view">
    <!-- Media object starts -->
    <div class="row">
      <div class="col-12 col-sm-7">
        <div class="media d-flex align-items-center">
          <div *ngIf="batchData?.image">
            <img class="users-avatar-shadow rounded mr-1" [src]="imageUrl + batchData?.image"
              height="64" width="64" alt="datatable-avatar">
          </div>
          
            <div *ngIf="!batchData?.image" [class.initial-alpha]="!batchData?.image" class="users-avatar-shadow rounded mr-1 ml-0" >
              <div class="avatar-content">{{ batchData?.name | shortName }}</div>
            </div>
          <div class="media-body ml-3">
            <h4>
              <span class="users-view-name mr-1">{{ batchData?.name }}</span>
              <!-- <span class="text-muted font-medium-1">
                  <span>@</span>
                  <span class="users-view-username">dean3004</span>
                </span> -->
            </h4>
            <span class="mr-1">ID:</span>
            <span class="users-view-id">{{
              batchData?._id.substring(batchData?._id.length - 6)
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-5 d-flex justify-content-end align-items-center">
        <a
          [routerLink]="['/batches/edit-batch', batchData?._id]"
          class="btn btn-sm btn-primary px-3 py-1"
          >Edit</a
        >
      </div>
    </div>
    <!-- Media object ends -->
  
    <div class="row">
     
      <div class="col-12">
        <!-- Batch detail starts -->
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="col-12">
                <h5 class="mb-2 text-bold-500">
                  <i class="ft-info mr-2"></i> Batch Info
                </h5>
                <div class="table-responsive">
                  <table class="table table-borderless">
                    <tbody>
                      <tr>
                        <td>Name:</td>
                        <td class="users-view-username">
                          {{ batchData?.name}}
                        </td>
                      </tr>
                      <tr>
                        <td>Course</td>
                        <td class="users-view-username">
                            {{ batchData?.course_id?.title}}
                        </td>
                      </tr>
                      <tr>
                        <td>Start Date:</td>
                        <td class="users-view-username">
                            {{ batchData?.start_date}}
                        </td>
                      </tr>
                      <tr *ngIf="batchData?.joiningLink">
                        <td>Joining Link</td>
                        <td class="users-view-username">
                            {{ batchData?.joining_link}}
                        </td>
                      </tr>
                      <tr>
                        <td>Start Time:</td>
                        <td class="users-view-username">
                            {{ batchData?.start_time }}
                        </td>
                      </tr>
                      <tr>
                        <td>End Time:</td>
                        <td class="users-view-username">
                            {{ batchData?.end_time}}
                        </td>
                      </tr>
                      <tr>
                        <td>Days:</td>
                        <td  [innerText]="batchData?.days" >                       
                        </td>
                      </tr>
                    
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Course detail ends -->
      </div>
      <div class="col-12"> 
        
        <div class="card">
            <div class="card-content">
              <div class="card-body">
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-borderless">
                      <tbody>
                        <tr>
                          <td>Registered:</td>
                          <td>{{ batchData?.created_at | date: "mediumDate" }}</td>
                        </tr>
                        <tr>
                          <td>Latest Activity:</td>
                          <td class="users-view-latest-activity">
                            {{ batchData?.updated_at | date: "mediumDate" }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="student-box">
                    <p>Students : </p>
                    <div  *ngFor="let student of student_list; last as isLast">
                      <span class="bg-light-primary badge badge-pill">
                        {{student?.name}}
                      </span>
                      
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> 
        </div>
  
  
  
  
      <!-- <div class="col-12">
      
         <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="col-12">
               
                <div class="table-responsive">
                  <table class="table mb-0" >
                   
                    <tbody>
                      <tr>
                        <td>Name:</td>
                        <td class="users-view-username">
                          {{ batchData?.name}}
                        </td>
                      </tr>
                      <tr>
                        <td>Registered:</td>
                        <td>{{ batchData?.created_at | date: "mediumDate" }}</td>
                      </tr>
                      <tr>
                        <td>Latest Activity:</td>
                        <td class="users-view-latest-activity">
                          {{ batchData?.updated_at | date: "mediumDate" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                 
                </div>
              </div>
            </div>
          </div>
        </div> 
      
      </div> -->
    </div>
  </section>
  